/**
 * Currency conversion helper — FIXED PARITY (CFA franc fixe with EUR).
 *
 * 1 EUR = 655.957 XOF/XAF (the BCEAO and BEAC issue currencies with the
 * same fixed parity to the euro since 1999). We round to 655 for display.
 *
 * Used by /p/pricing and Marketplace to switch currency display without
 * any live FX call (deliberate UX choice: predictability for African SMEs).
 */
export const FX_RATE = 655;

export const CURRENCIES = [
    { code: 'EUR', label: '€', name: 'Euro' },
    { code: 'XOF', label: 'FCFA', name: 'Franc CFA (UEMOA)' },
    { code: 'XAF', label: 'FCFA', name: 'Franc CFA (CEMAC)' },
];

export function convertFromEUR(amountEur, code) {
    if (!amountEur && amountEur !== 0) return null;
    if (code === 'EUR') return amountEur;
    return Math.round(amountEur * FX_RATE);
}

export function formatPrice(amountEur, code) {
    if (amountEur === null || amountEur === undefined) return '';
    const value = convertFromEUR(amountEur, code);
    const label = (CURRENCIES.find(c => c.code === code) || CURRENCIES[0]).label;
    if (code === 'EUR') return `${value} ${label}`;
    return `${new Intl.NumberFormat('fr-FR').format(value)} ${label}`;
}
